export const reports = {
  All_reports: "Todos los informes",
  Areas_for_Improvement: "Áreas para mejorar",
  Assessment: "Evaluación",
  Assessment_of_Conformity: "Evaluación de la conformidad",
  Assessment_Detail_Report_Link: "Enlace al Informe Detallado de Evaluación",
  Conformity_Level: "Nivel de conformidad",
  Conformity_levels_may_have_been_adjusted:
    "Tenga en cuenta que los niveles de conformidad de este informe resumido de normas pueden haber sido ajustados para cumplir la directriz de cada organismo de normalización, lo que puede dar lugar a un nivel de conformidad diferente del evaluado originalmente.",
  aggregate_levels: {
    label: "Agrupar nivel de conformidad en",
    requirement: "Requisito",
    sub_section: "Subsección",
    section: "Sección",
  },
  custom_report: {
    Add_report_name: "Agregar nombre del informe",
    aggregated: "Agregado",
    Are_you_sure_you_want_to_delete_report: "¿Estás seguro de que quieres eliminar el informe?",
    Are_you_sure_you_want_to_modify_report_name: "¿Estás seguro de que quieres modificar el nombre del informe?",
    Conformity_level: "Nivel de conformidad",
    Create_Custom_Report: "Crear informe personalizado",
    Download_entire_table: "Descargar tabla completa",
    "Download_filtered_&_customized_table": "Descargar tabla filtrada y personalizada",
    Export_to_file: "Exportar a archivo",
    Name_cannot_be_empty: "El nombre no puede estar vacío",
    Please_define_data_for_your_custom_report: "Por favor defina los datos para su informe personalizado",
    Report_name: "Nombre del informe",
    requirement: "Requisito",
    section: "Sección",
    section_ref: "Sección Ref.",
    Select_an_assessment: "Seleccionar una evaluación",
    Select_sites_and_facilities: "Seleccionar sitios e instalaciones",
    Select_standards: "Seleccionar estándares",
    standard_name: "Nombre estándar",
    standard_reference: "Referencia estándar",
    sub_section: "Subsección",
    sub_section_ref: "Subsección Ref.",
    This_action_cannot_be_undone: "Esta acción no se puede deshacer.",
    This_file_will_contain_report_based_on_all_the_customizations_and_filters_you_have_applied:
      "Este archivo contendrá un informe basado en todas las personalizaciones y filtros que haya aplicado.",
    This_file_will_contain_whole_report: "Este archivo contendrá todo el informe.",
    Use_this_window_to_create_multi_site_multi_standard_report:
      "Utilice esta ventana para crear un informe multisitio y multiestándar",
  },
  Custom_Reports: "Informes personalizados",
  Customize_table: "Personalizar tabla",
  Download_entire_report: "Descargar informe completo",
  Download_filtered_customized_report: "Descargar informe filtrado y personalizado",
  Download_report: "Descargar informe",
  Evidence: "Evidencia",
  Evidence_Description: "Descripción de la evidencia",
  filteredRecords_Results: "{{filteredRecords}} Resultados",
  Group_by: "Agrupar por",
  Group_by_assessment: "Agrupar por evaluación",
  Group_by_site: "Agrupar por sitio",
  In_progress: "En curso",
  Internal_audit_required: "Auditoría interna",
  IRMA_Achievement_Level: "Nivel de logro de IRMA",
  Please_select_the_preferred_format: "Por favor seleccione el formato preferido",
  Protocol_ID: "ID de protocolo",
  Protocol_Question: "Pregunta de protocolo",
  Reference: "Referencia",
  Reports: "Informes",
  Requirement: "Requisito",
  Reset_to_default: "Restablecen a los predeterminados",
  Section: "Sección",
  Section_ref: "Sección Ref.",
  Site_name: "Nombre del sitio",
  Stakeholder_approval_required: "Aprobación de los interesados",
  Standard: "Estándar",
  Standard_Reference: "Referencia estándar",
  Status: "Estado",
  Sub_Section: "Subsección",
  Sub_Section_Ref: "Subsección Ref.",
  Sub_Theme: "Subtema",
  Table_customization: "Personalización de la mesa",
  Theme: "Tema",
  This_assessment_is_in_progress_The_assessment_data_you_are_viewing_are_subject_to_change:
    "Esta evaluación está en progreso. Los datos de evaluación que está viendo están sujetos a cambios.",
  This_report_will_contain_all_protocol_questions_for_title_for_siteName:
    "Este informe contendrá todas las preguntas de protocolo para {{- title}} para {{- siteName}}.",
  This_report_will_contain_protocol_questions_for_title_for_siteName_based_on_all_the_customizations_and_filters_you_have_applied:
    "Este informe contendrá preguntas de protocolo para {{- title}} para {{- siteName}} según todas las personalizaciones y filtros que haya aplicado",
  totalRecords_Results: "{{totalRecords}} Resultados",
} as const;
